import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const searchQueryFilter: QueryParameterSchema<'searchQuery'> = {
  getValue: ({ parameters }) => parameters.searchQuery,
  getDefaultValue: ({ defaultParameters }) => defaultParameters.searchQuery || undefined,

  toUrlSearchParams: ({ value }) => (value ? { 'filter[q]': value } : null),
  toSearchQuery: ({ value }) => (value ? { 'filter[q]': value } : null),
  fromUrlSearchParams: ({ urlSearchParams }) => ({
    searchQuery: urlSearchParams.get('filter[q]') || undefined,
  }),
};
